export const ONLY_LETTERS = /[^áâãéêíîóôõúûÁÂÃÉÊÍÎÓÔÕÚÛa-z ]/gi;

export function countWords(text: string) {
  return text?.match(/\w+/g)?.length || 0;
}

/**
 * Escapa os metacaracteres de regex de um texto, para poder usá-lo dentro de um pattern
 * construído em runtime.
 *
 * Necessário porque o filtro do SearchCard monta o pattern com o que o lead digitou:
 * sem escape, digitar `]`, `\`, `(` ou `[` gera pattern inválido e `RegExp()` lança,
 * derrubando a busca inteira.
 */
export function escapeRegExp(text: string): string {
  return (text || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
